"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _attributeIds = require("@devsontap/nica-api/core/utils/attributeIds");

var _customField = _interopRequireDefault(require("../../../../_common/formik/customField"));

var _attributeSection = _interopRequireDefault(require("../attributes/attributeSection"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MedicationsAvailable = function MedicationsAvailable(_ref) {
  var setFieldValue = _ref.setFieldValue;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-3 w-full"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _attributeSection.default,
    name: "attributes.".concat(_attributeIds.medicationsAvailable),
    key: "attribute-section-".concat(_attributeIds.medicationsAvailable),
    attributeId: _attributeIds.medicationsAvailable,
    errorField: "choice",
    setFieldValue: setFieldValue,
    showLabel: false,
    fast: true
  }));
};

var _default = MedicationsAvailable;
exports.default = _default;